angular.module('cimerFrontEndApp').directive('displayLogicHeader', [function () {
    "use strict";
    return {
        restrict: 'EA',
        templateUrl: '/Content/Templates/displayLogicHeaderTemplate.html',
        scope: {
            promptQuestionCount: '=promptQuestionCount',
            questionBranches: '=questionBranches'
        }
    };
}]);